import AScene from "../library/ExtendedObjects/AScene.js";
import AMatterSprite from "../library/ExtendedObjects/AMatterSprite.js";

export default class Test extends AScene
{
    create()
    {
        this.matter.add.mouseSpring({ length: 0, stiffness: 0 });
        let ham = this.matter.add.sprite(300, 300, "hammerAnim", null);
        

        let bill = new TestItem(this, this.mid.x, 100, "fiveAnim");
        this.add.existing(bill);
    }
}

export class TestItem extends AMatterSprite
{
    constructor(scene, x, y, animation)
    {
        super(scene, x, y, animation)
    }
}
